import { h } from 'preact';
import { useEffect, useState, useContext } from 'preact/hooks';
import { Control2 } from './menu';

export const fullScreen = function(p) {
  const { setCtl2 } = useContext(Control2);
  const [fullscr, setFullscr] = useState(false);
  useEffect(() => {
    const changeCb = e => setFullscr(!!isFullScreen());
    changeCb();
    document.addEventListener('fullscreenchange', changeCb);
    return () => document.removeEventListener('fullscreenchange', changeCb);
  }, [p.lsName]);
  const toggleFullscr = e => {
    if (fullscr) closeFullscreen().then(x => setFullscr(false), x => setFullscr(true));
    else openFullscreen().then(x => setFullscr(true), x => setFullscr(false));
  };
  let name = (fullscr ? 'Exit' : 'Activate') + ' Full Screen';
  if (p.short) name = (fullscr ? '(fs)' : '[FS]');
  useEffect(() => {
    if (fullscr) setCtl2(h('div', { class: 'pre-menu2 op1', onClick: toggleFullscr }, '()'));
    else setCtl2(h('div', { class: 'pre-menu2', onClick: toggleFullscr }, '[]'));
  }, [fullscr]);
  return h('div', { class: 'ctl-component' }, h('button', {
    onClick: toggleFullscr,
  }, name));
};

const isFullScreen = () =>
  document.fullscreenElement /* Standard syntax */
  || document.webkitFullscreenElement /* Chrome, Safari and Opera syntax */
  || document.mozFullScreenElement/* Firefox syntax */
  || document.msFullscreenElement /* IE/Edge syntax */
  ;

/* View in fullscreen */
function openFullscreen(elem) {
  if (!elem) elem = document.documentElement;
  const opt = { navigationUI: 'hide' };
  if (elem.requestFullscreen) {
    return elem.requestFullscreen(opt);
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    return elem.mozRequestFullScreen(opt);
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    return elem.webkitRequestFullscreen(opt);
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    return elem.msRequestFullscreen(opt);
  }
}

/* Close fullscreen */
function closeFullscreen(elem) {
  if (!elem) elem = document.documentElement;
  if (document.exitFullscreen) {
    return document.exitFullscreen();
  } else if (document.mozCancelFullScreen) { /* Firefox */
    return document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
    return document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { /* IE/Edge */
    return document.msExitFullscreen();
  }
}
